

















































import { Component, Vue } from 'vue-property-decorator';
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import SubscriptionService from '@/services/SubscriptionService';
import Page, { EMPTY_PAGE } from '@/dto/taxation/Page';
import AgreementBriefDTO from '@/dto/subscription/AgreementBriefDTO';
import { Periodicity } from '@/dto/subscription/SubscriptionPlanDTO';
import { processError } from '@/utils/ComponentUtils';

@Component({
  components: { PaginationComponent },
})
export default class AllSubscriptions extends Vue {
  private loading = false;
  private pageSize = 20;
  private subscriptions: Page<AgreementBriefDTO & { periodicity: Periodicity }> = { ...EMPTY_PAGE };

  mounted() {
    this.load();
  }

  private changePage(page: number) {
    this.load(page );
  }

  private load(pageNumber = 1) {
    this.loading = true;
    SubscriptionService.getAllSubscriptions(pageNumber, this.pageSize).then(
      ok => {
        this.subscriptions = ok.data;
        this.loading = false;
      },
      err => {
        this.loading = false;
        processError(err, this);
      }
    );
  }
}
